import type { RFCanvasMeta } from '@src/types/reframe';
import { v4 as uuidv4 } from 'uuid';

let isVisible = $state(false);
let isEnabled = $state(false);
let selectedCanvases: (RFCanvasMeta & { key: string })[] = $state([]);
let inspectorMode: 'canvas' | 'grid' | 'light-table' = $state('canvas');

export const openInspector = (canvasMeta?: RFCanvasMeta) => {
	selectedCanvases = [];
	if (canvasMeta) {
		const withKey = {
			...canvasMeta,
			key: uuidv4(),
		};
		selectedCanvases.push(withKey);
	}
	isVisible = true;
	inspectorMode = 'canvas';
};

export const closeInspector = () => {
	selectedCanvases = [];
	isVisible = false;
};

export const enableInspector = () => {
	isEnabled = true;
};

export const disableInspector = () => {
	isEnabled = true;
};

export const addSelectedCanvas = (canvasMeta: RFCanvasMeta & { key: string }) => {
	const withKey = {
		...canvasMeta,
		key: canvasMeta?.key || uuidv4(),
	};
	selectedCanvases.push(withKey);
};

export const clearSelectedCanvases = () => {
	selectedCanvases = [];
};

export const removeSelectedCanvas = (key: string) => {
	selectedCanvases = selectedCanvases.filter((canvas) => canvas.key !== key);
};

export const inspectorStore = {
	get isVisible() {
		return isVisible;
	},
	get selectedCanvases() {
		return selectedCanvases;
	},
	get isEnabled() {
		return isEnabled;
	},
	get inspectorMode() {
		return inspectorMode;
	},
	set inspectorMode(value: 'canvas' | 'grid' | 'light-table') {
		inspectorMode = value;
	},
	openInspector,
	closeInspector,
	enableInspector,
	disableInspector,
	addSelectedCanvas,
	clearSelectedCanvases,
	removeSelectedCanvas,
};

export default inspectorStore;
